import React from "react";
import { Text } from "../design-system/components/Text";
import { Heading } from "../design-system/components/Heading";
import Divider from "./Divider";
import { Illustration } from "../design-system/components/Illustration";
import styled from "../styled";

const BannerWrap = styled.div`
  display: flex;
`;

const Image = styled(Illustration)`
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.s}) {
    display: block;
  }
`;

export const ReferralBannerSignup = ({
  referralName,
  referralValue
}: {
  referralName: string;
  referralValue: string;
}) => {
  return (
    <>
      <BannerWrap>
        <div>
          <Heading size="l" margin="0 0 s">
            Looks like you used an invite link
          </Heading>
          <Text margin="0 0 s">
            Sign up to our mailing list to earn £{referralValue} towards a gift
            voucher or charity donation for both you and {referralName}.
          </Text>
          <Text>You do not need make us your preferred pharmacy.</Text>
        </div>
        <Image src="small-gift-card-floating-bow" margin="0 0 0 m" />
      </BannerWrap>
      <Divider margin="l 0" />
    </>
  );
};
